import React, { useState, useEffect, useCallback } from "react";
import { Link, useNavigate } from "react-router-dom";
import axios from "axios";
import {
    Button,
    Col,
    Container,
    Row,
    Form,
    Modal,
    DropdownButton,
    Dropdown
} from "react-bootstrap";
import { Bars } from "react-loader-spinner";
import { ColorRing } from "react-loader-spinner";
import { toast } from "react-toastify";
import { getNewToken } from "../config/cookie.config";
import { MdOutlineKeyboardBackspace } from "react-icons/md";
const Maintenance = () => {
    useEffect(() => {
        const adminCheck = window.location.pathname;
        if (adminCheck.includes('admin')) {
            document.title = "ncentiva || Site Management"
        }
    }, [])


    let token;
    let uid;
    const user = JSON.parse(window.localStorage.getItem("client"));
    if (user) {
        token = user.token;
        uid = user.user._id
    } else {
        token = null;
        uid = null
    }
         
    const navigate = useNavigate()
    const [minDate, setMinDate] = useState('');
    useEffect(() => {
      const dtToday = new Date();
      const month = dtToday.getMonth() + 1;
      const day = dtToday.getDate();
      const year = dtToday.getFullYear();
      const formattedMonth = month < 10 ? `0${month}` : month;
      const formattedDay = day < 10 ? `0${day}` : day;
      const minDate = `${year}-${formattedMonth}-${formattedDay}`;
      setMinDate(minDate);
    }, []); 

    const [isDisable, setIsDisable] = useState(false);
    const [selectedDate, setSelectedDate] = useState('');
    const [startTime, setStartTime] = useState('');
    const [endTime, setEndTime] = useState('');
    const [documentData,setDocumentData] = useState({});
    const [uploadModal,setUploadModal] = useState(false)
    const [uploadModalTwo,setUploadModalTwo] = useState(false)
    const [selectedFile, setSelectedFile] = useState(null);
    const [selectedFileTwo,setSelectedFileTwo] = useState(null);
    const [fileName,setFileName] = useState("");
    const [fileNameTwo,setFileNameTwo] = useState('');
    const [docFileType,setDocFileType] = useState("")
    const [isUploadFile, setIsUploadFile] = useState(false);
    const [isUploadFileTwo, setIsUploadFileTwo] = useState(false);
    const [isLoadingDocument, setIsLoadingDocument]=useState(true);
    const [maintenanceData, setMaintenanceData] = useState([]);
    const [notificationData, setNotificationData] = useState([]);
    const [showNotificationModal, setShowNotificationModal] = useState(false);
    const [formData, setFormData] = useState({ notificationType: '', email: '' });

    const handleDateChange = (e) => {
        setSelectedDate(e.target.value);
    };

    const handleEndTimeChange = (e) => {
        setEndTime(e.target.value);
    };


    useEffect(() => {
        const getCurrentDate = () => {
            const now = new Date();
            const year = now.getFullYear();
            const month = (now.getMonth() + 1).toString().padStart(2, '0');
            const day = now.getDate().toString().padStart(2, '0');
            return `${year}-${month}-${day}`;
        };
        setSelectedDate(getCurrentDate());
    }, []);

    const handleStartTimeChange = (event) => {
        const { value } = event.target;
        setStartTime(value);
    };

    const handleSave = () => {
            setIsDisable(true)
        if (!selectedDate) {
            toast.warning("Please provide the date");
            setTimeout(() => {
            setIsDisable(false);
        }, 1000);
            return;
        }
        if (!startTime) {
            toast.warning("Please provide the start time");
            setTimeout(() => {
            setIsDisable(false);
        }, 1000);
            return;
        }
        if (!endTime) {
            toast.warning("Please provide the end time");
            setTimeout(() => {
            setIsDisable(false);
        }, 1000);
            return;
        }
        if(selectedDate < minDate){
            toast.warning("Can not Give Previous Date");
            setTimeout(() => {
            setIsDisable(false);
        }, 1000);
            return;
        }

        const startTimeParts = startTime.split(":").map(Number);

       

        const endTimeParts = endTime.split(":").map(Number);

        const startTimeMinutes = startTimeParts[0] * 60 + startTimeParts[1];
        const endTimeMinutes = endTimeParts[0] * 60 + endTimeParts[1];

 
        if (startTimeMinutes >= endTimeMinutes) {
            toast.warning("End time cannot be earlier than or equal to start time");
            setTimeout(() => {
            setIsDisable(false);
        }, 1000);
            return;
        }

        const data = {
            date: selectedDate,
            startTime: startTime,
            endTime: endTime,
            user_id: uid,
            update: false
        };
        if (maintenanceData.length > 0) {
            setShow(true)
            setTimeout(() => {
            setIsDisable(false);
        }, 1000);
            return;
        }

        axios
            .post(`${process.env.REACT_APP_BACKEND_BASE_URL}api/admin/set-maintenance`, data, {
                headers: {
                    'Authorization': `Bearer ${getNewToken()}`
                }
            })
            .then((response) => {
                if (response.data.status === "success") {
                    toast.success(response.data.message)
                    getMmaintenance()
                    setStartTime('');
                    setEndTime('');
                    setTimeout(() => {
                        setIsDisable(false);
                    }, 1000);
                } else {
                    toast.error(response.data.message)
                    setTimeout(() => {
                        setIsDisable(false);
                    }, 1000);
                }
            })
            .catch((error) => {
                setTimeout(() => {
                    setIsDisable(false);
                }, 1000);
                console.log(`Error: ${error}`)
                if (error.response.data.message) {
                    localStorage.removeItem('client');
                    localStorage.removeItem('user');
                    navigate('/admin');
                    // toast.error("Session Expired. Please Login Again")
                  }
            })
    }


    const handleCancel = (id) => {
        axios
            .delete(`${process.env.REACT_APP_BACKEND_BASE_URL}api/admin/delete-maintenance-data/${id}`, {
                headers: {
                    'Authorization': `Bearer ${getNewToken()}`
                }
            })
            .then((response) => {
                if (response.data.status === "success") {
                    toast.success(response.data.message)
                    getMmaintenance()
                } else {
                    toast.error(response.data.message)
                }
            })
            .catch((error) => {
                console.log(`Error: ${error}`)
            })
    }

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFormData({ ...formData, [name]: value });
    };

    const handleNotificationSubmit = async (e) => {
        e.preventDefault();
        try {
            const response = await axios.post(`${process.env.REACT_APP_BACKEND_BASE_URL}api/admin/notification/create`, formData);
            if (response.data.status === "success") {
                toast.success(response?.data?.message || "Notification Created Successfully");
                handleNotificationClose();
                getNotificationData();
                setFormData({ email: '', notificationType: '' })
            } else {
                toast.warning(response?.data?.message || "Unable to create notification");
            }
        } catch (error) {
            console.error('Error creating notification:', error);
            toast.error(error.response?.data?.message || "Unable to create notification");  
        }
    };

    const handleNotificationClose = () => {
        setShowNotificationModal(false);
    }
    const handleNotificationShow = () => {
        setShowNotificationModal(true);
    }

    const handleNotificationDelete = async (id) => {
        try {
            const response = await axios.delete(`${process.env.REACT_APP_BACKEND_BASE_URL}api/admin/notifications/${id}`);
            if (response.data.status === "success") {
                toast.success("Notification deleted successfully");
                getNotificationData()
            } else {
                toast.warning(response.data.message);
            }
        } catch (error) {
            console.error('Error deleting notification:', error);
            toast.error("Unable to delete notification");
        }
    };


    const getMmaintenance = useCallback(() => {
        axios.get(`${process.env.REACT_APP_BACKEND_BASE_URL}api/admin/get-maintenance`, {
            headers: {
                'Authorization': `Bearer ${getNewToken()}`
            }
        })
            .then((res) => {
                setMaintenanceData(res.data.data);
            })
            .catch((err) => {
                console.error(err);
                if (err.response.data.message) {
                    localStorage.removeItem('client');
                    localStorage.removeItem('user');
                    navigate('/admin');
                    // toast.error("Session Expired. Please Login Again")
                }
            });
    }, [token, setMaintenanceData, navigate]);
    
    const getNotificationData = useCallback(() => {
        axios
            .get(`${process.env.REACT_APP_BACKEND_BASE_URL}api/admin/get/notifications`, {
                headers: {
                    'Authorization': `Bearer ${getNewToken()}`
                }
            })
            .then((res) => {
                setNotificationData(res.data.notifications);
            })
            .catch((err) => {
                console.error(err);
                if (err.response.data.message) {
                    localStorage.removeItem('client');
                    localStorage.removeItem('user');
                    navigate('/admin');
                }
            });
    }, [token, setNotificationData, navigate]);
    
    useEffect(() => {
        getMmaintenance();
        getNotificationData();
    }, [getMmaintenance, getNotificationData]);
    

    const [show, setShow] = useState(false);
    const handleClose = () => {
        setShow(false);
    }


    const confirmSave = () => {
        setIsDisable(true)
        const data = {
            date: selectedDate,
            startTime: startTime,
            endTime: endTime,
            user_id: uid,
            update: true
        };
        axios
            .post(`${process.env.REACT_APP_BACKEND_BASE_URL}api/admin/set-maintenance`, data, {
                headers: {
                    'Authorization': `Bearer ${getNewToken()}`
                }
            })
            .then((response) => {
                if (response.data.status === "success") {
                    toast.success(response.data.message)
                    setShow(false);
                    getMmaintenance()
                    setStartTime('');
                    setEndTime('');
                    setTimeout(() => {
                        setIsDisable(false);
                    }, 1000);
                } else {
                    toast.error(response.data.message)
                    setTimeout(() => {
                        setIsDisable(false);
                    }, 1000);
                }
            })
            .catch((error) => {
                console.log(`Error: ${error}`)
                setTimeout(() => {
                    setIsDisable(false);
                }, 1000);
            })
    }

    const getDocument = () =>{
        setIsLoadingDocument(true)
        axios.get(`${process.env.REACT_APP_BACKEND_BASE_URL}api/admin/getTermsConditionAndPrivacyPolicyFile`)
        .then((response)=>{
           setDocumentData(response?.data)
           setIsLoadingDocument(false)
   
        })
        .catch((error)=>{
        console.log(error);
        })
    }

    useEffect(()=>{
        getDocument()
    },[])

    const downloadTermsandCondition = (url) =>{
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', ''); 
        link.setAttribute('target', '_blank'); 
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    }
    
      const downloadFile = (FileType) =>{
        axios.get(`${process.env.REACT_APP_BACKEND_BASE_URL}api/admin/download/${FileType}`)
        .then((response)=>{
        downloadTermsandCondition(response?.data.url)
         })
        .catch((err)=>{
          console.log(err);
          toast.warning(err.response?.data?.error)
        })
      }

      const handleFileprivacy = (event) =>{
        setFileNameTwo(event?.target?.files[0]?.name);
        setSelectedFileTwo(event.target.files[0]);
      }

      const handleFileTerms = (event) => {
        setFileName(event?.target?.files[0]?.name)
        setSelectedFile(event.target.files[0]);
        
      };

    const uploadDocument = () => {
        setIsUploadFile(true);
        const allowedFileTypes = [
            "application/pdf",
            "application/msword",
            "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
        ];
        const file = selectedFile;
        if (file && allowedFileTypes.includes(file.type) && fileName) {
            const formData = new FormData();
            formData.append('file', file);

            axios.post(`${process.env.REACT_APP_BACKEND_BASE_URL}api/admin/upload/${docFileType}`, formData, {
                headers: {
                    'Content-Type': 'multipart/form-data'
                }
            })
                .then((response) => {
                    if (response?.data?.status === "success") {
                        toast.success(response?.data?.message)
                        setIsUploadFile(false);
                        setUploadModal(false);
                        getDocument();
                        setFileName("");
                        setSelectedFile(null);
                    }

                })
                .catch((error) => {
                    setIsUploadFile(false);
                    console.log(error);
                })

        } else {
            setIsUploadFile(false);
            toast.warning("Please upload a valid file (PDF or DOC)");
        }
    }

    const uploadDocumnetPrivacy = () => {
        setIsUploadFileTwo(true);
        const allowedFileTypes = [
            "application/pdf",
            "application/msword",
            "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
        ];
        const file = selectedFileTwo

        if (file && allowedFileTypes.includes(file.type) && fileNameTwo) {
            const formData = new FormData();
            formData.append('file', file);

            axios.post(`${process.env.REACT_APP_BACKEND_BASE_URL}api/admin/upload/${docFileType}`, formData, {
                headers: {
                    'Content-Type': 'multipart/form-data'
                }
            })
                .then((response) => {
                    if (response?.data?.status === "success") {
                        toast.success(response?.data?.message)
                        setIsUploadFileTwo(false);
                        setUploadModalTwo(false);
                        getDocument();
                        setFileNameTwo("");
                        setSelectedFileTwo(null);
                    }

                })
                .catch((error) => {
                    setIsUploadFileTwo(false);
                    console.log(error);
                })
        } else {
            setIsUploadFileTwo(false);
            toast.warning("Please upload a valid file (PDF or DOC)");
        }
    }

    const uploadFile = (FileType) => {
        setDocFileType(FileType)
        if (FileType === "termsAndCondition") {
            setUploadModal(true)
            setUploadModalTwo(false)
        } else {
            setUploadModal(false)
            setUploadModalTwo(true)
        }
    }

     const deleteFile = (FileType,fileLink) =>{
       axios.delete(`${process.env.REACT_APP_BACKEND_BASE_URL}api/admin/delete/${FileType}`,{
        data:{
            fileLink:fileLink
        }
       })
       .then((response)=>{
        getDocument()
       })
       .catch((err)=>{
      console.log(err);
       })
      }

const closeUploadModal = () =>{
    setUploadModal(false);
    setFileName("");
    setSelectedFile(null);
}
const closeUploadModalTwo = () =>{
    setUploadModalTwo(false);
    setFileNameTwo("");
    setSelectedFileTwo(null);
}
    return (
        <>
            <div className="p-3 p-lg-5">
                <div className="d-flex mb-4 align-items-center">
                    <Link
                        to="/admin/businesspartners"
                        className="p-0 btn btnOrangeTransparent me-3 fw-semibold"
                        variant="white"
                    >
                        <span className="me-2 fw-semibold">
                            {/* <img
                                src="/assets/images/back-org.png"
                                className="img-fluid"
                                alt=""
                            /> */}
                            <MdOutlineKeyboardBackspace  className="fs-4" style={{color: 'var(--newOrange)'}}/>
                        </span>
                        <span>Back</span>
                    </Link>
                    <h1 className="font20 text-dark">Site Management</h1>
                </div>
                {maintenanceData.length > 0 ?
                    <Col md={12} className="mt-4">
                        <div className="table-responsive">
                            <table className="table " style={{ verticalAlign: "middle" }}>
                                <thead className="bgLightRed font14">
                                    <tr className="text-center">
                                        <th className="py-3">
                                            <div className="d-flex align-items-center justify-content-center" style={{ cursor: 'pointer' }}>
                                                <span className="me-1">Date</span>
                                            </div>
                                        </th>
                                        <th className="py-3">
                                            <div className="d-flex align-items-center justify-content-center" style={{ cursor: 'pointer' }}>
                                                <span className="me-1">Start Time</span>
                                            </div>
                                        </th>
                                        <th className="py-3">
                                            <div className="d-flex align-items-center justify-content-center" style={{ cursor: 'pointer' }}>
                                                <span className="me-1">End Time</span>
                                            </div>
                                        </th>
                                        <th className="py-3">
                                            <div className="d-flex align-items-center justify-content-center" style={{ cursor: 'pointer' }}>
                                                <span className="me-1">Status</span>
                                            </div>
                                        </th>
                                        <th className="py-3">
                                            <div className="d-flex align-items-center justify-content-center" style={{ cursor: 'pointer' }}>
                                                <span className="me-1">Action</span>
                                            </div>
                                        </th>
                                    </tr>
                                </thead>
                                <tbody className="font14 fw-medium text-center">
                                    {maintenanceData.map((cust) => (
                                        <tr key={cust._id}>
                                            <td>{cust.date}</td>
                                            <td>{cust.startTime}</td>
                                            <td>{cust.endTime}</td>
                                            <td>{cust.isMaintenance ? 'Maintenance' : 'Not in Maintenance'}</td>
                                            <td>
                                                <Button variant="primary" className="fullRounded px-4 px-lg-3 px-xl-4 py-2 fw-bold font12" onClick={() => handleCancel(cust._id)}>
                                                    Cancel
                                                </Button>
                                            </td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        </div>
                    </Col> : ""}
                <Container fluid className="mt-4 bg-white p-4 rounded shadow">
                    <Row>
                        <Col md={4}>
                            <h1 className="font20 mb-4 text-dark">Schedule Site Downtime</h1>
                        </Col>
                        <Col md={4}></Col>
                        <Col md={4}></Col>
                    </Row>

                    <div className="col-12 mt-4">
                        <label htmlFor="selectedDate">Select Date</label>
                        <ul className="list-unstyled Emaillist_button g-3">
                            <li className="d-flex">
                                <Form.Control
                                    id="selectedDate"
                                    name='selectedDate'
                                    type="date"
                                    className="font16"
                                    style={{ height: "46px" }}
                                    placeholder='Choose Date'
                                    min={minDate}
                                    value={selectedDate}
                                    onChange={handleDateChange}
                                />
                            </li>
                        </ul>
                    </div>

                    <div className='row'>
                        <div className='col-6 mt-4'>
                            <label className="labelWhiteSpace" htmlFor="startTime">Start Time (US eastern time)</label>
                            <ul className='list-unstyled Emaillist_button g-3'>
                                <li className='d-flex '>
                                    <Form.Control
                                        id="startTime"
                                        name='startTime'
                                        type="time"
                                        className="font16"
                                        style={{ height: "46px" }}
                                        value={startTime}
                                        onChange={handleStartTimeChange}
                                        placeholder='Start Time'
                                    />
                                </li>
                            </ul>
                        </div>
                        <div className='col-6 mt-4'>
                            <label htmlFor="endTime" >End Time<span className="spanWhiteSpace"> </span>(US eastern time)</label>
                            <ul className='list-unstyled Emaillist_button g-3'>
                                <li className='d-flex '>
                                    <Form.Control
                                        id="endTime"
                                        name='endTime'
                                        type="time"
                                        className="font16"
                                        style={{ height: "46px" }}
                                        value={endTime}
                                        onChange={handleEndTimeChange}
                                        placeholder='End Time'
                                    />
                                </li>
                            </ul>
                        </div>
                    </div>
                    <div className="mt-4 buttonCenterMobile">
                        {isDisable? <Button variant="primary"
                            className="fullRounded newCustomButton px-4 px-lg-3 px-xl-4 py-2 fw-bold font12" style={{ minWidth: "140px", backgroundColor:"var(--newOrange)", borderColor:"var(--newOrange)" }} disabled>Save</Button>:
                        <Button variant="primary"
                            className="fullRounded newCustomButton px-4 px-lg-3 px-xl-4 py-2 fw-bold font12" style={{ minWidth: "140px", backgroundColor:"var(--newOrange)", borderColor:"var(--newOrange)" }} onClick={handleSave}>Save</Button>}
                    </div>
                </Container>


                <Container fluid className="mt-5 bg-white p-4 rounded shadow">
                    <div >
                        <h1 className="font20 text-dark">Document Upload</h1>
                        <div className="table-responsive mt-5">
                            <table className="table table_style">
                                <thead className='bgLightRed font14'>
                                    <tr>
                                        <th style={{ width: "135px" }}>Document</th>
                                        <th style={{ width: "230px" }}>File Name</th>
                                        <th style={{ width: "251px" }}>Last Updated On</th>
                                        <th style={{ width: "154px" }} className='text-center'>Action</th>
                                    </tr>
                                </thead>
                                <tbody>
                                {isLoadingDocument? (
                    <tr style={{ backgroundColor: "#eee" }}>
                      <td colSpan="9">
                        <Bars
                          height="80"
                          width="100%"
                          margin="auto"
                          color="var(--newMainBlue)"
                          ariaLabel="bars-loading"
                          wrapperStyle={{}}
                          wrapperClass=""
                          visible={true}
                        />
                      </td>
                    </tr>
                  ) : 
                                <>
                                    {documentData?.termsFile ?
                                        <tr>
                                            <td className="font14 fw-medium">
                                                Terms of Use
                                            </td>
                                            <td className="font14 fw-medium" style={{ color: "var(--newMainBlue)" }}>
                                              
                                                <a href={documentData?.termsFile?.fileLink} target="_blank" rel="noopener noreferrer">{documentData?.termsFile?.fileName ?? <> <span style={{ color: "black" }}>
                                                    No File uploaded
                                                </span></>}</a>
                                            </td>
                                            <td className="font14 fw-medium">
                                                {documentData?.termsFile?.dateInEst}
                                            </td>
                                            <td style={{ cursor: "pointer" }} className='svg_style text-center'>
                                                <DropdownButton
                                                    variant="white"
                                                    className="p-0 tableActionDropDown text-center"
                                                    title={
                                                        <div className="actionBtn">
                                                            <span></span>
                                                            <span></span>
                                                            <span></span>
                                                        </div>
                                                    }
                                                    drop="start"
                                                >
                                                    <div style={{ overflowY: "auto", maxHeight: "100px" }}>
                                                        <Dropdown.Item
                                                            className="font14 fw-medium"
                                                            onClick={() => {
                                                                uploadFile(documentData?.termsFile?.fileType)
                                                            }}
                                                        >
                                                            Upload
                                                        </Dropdown.Item>
                                                        { documentData?.termsFile?.fileName ? <>
                                                        <Dropdown.Item
                                                            className="font14 fw-medium"
                                                            onClick={() => {
                                                                downloadFile(documentData?.termsFile?.fileType)
                                                            }}
                                                        >
                                                            Download
                                                        </Dropdown.Item>
                                                        <Dropdown.Item
                                                            className="font14 fw-medium"
                                                            onClick={() => {
                                                                deleteFile(documentData?.termsFile?.fileType, documentData?.termsFile?.fileLink)
                                                            }}
                                                        >
                                                            Delete
                                                        </Dropdown.Item>
                                                        </> : ''}
                                                    </div>
                                                </DropdownButton>
                                            </td>
                                        </tr>
                                        :
                                        ""}
                                    {documentData?.privacyFile ?
                                        <tr>
                                            <td className="font14 fw-medium">
                                                Privacy Policy
                                            </td>
                                            <td className="font14 fw-medium" style={{ color: "var(--newMainBlue)" }}>
                                                
                                                <a href={documentData?.privacyFile?.fileLink} target="_blank" rel="noopener noreferrer">{documentData?.privacyFile?.fileName ?? <> <span style={{ color: "black" }}>
                                                    No File uploaded
                                                </span></>}</a>
                                            </td>
                                            <td className="font14 fw-medium">
                                                {documentData?.privacyFile?.dateInEst}
                                            </td>
                                            <td style={{ cursor: "pointer" }} className='svg_style text-center'>
                                                <DropdownButton
                                                    variant="white"
                                                    className="p-0 tableActionDropDown text-center"
                                                    title={
                                                        <div className="actionBtn">
                                                            <span></span>
                                                            <span></span>
                                                            <span></span>
                                                        </div>
                                                    }
                                                    drop="start"
                                                >
                                                        <div style={{ overflowY: "auto", maxHeight: "100px" }}>
                                                        <Dropdown.Item
                                                            className="font14 fw-medium"
                                                            onClick={() => {
                                                                uploadFile(documentData?.privacyFile?.fileType)
                                                            }}
                                                        >
                                                            Upload
                                                        </Dropdown.Item>
                                                         { documentData?.privacyFile?.fileName ? <>
                                                        <Dropdown.Item
                                                            className="font14 fw-medium"
                                                            onClick={() => {
                                                                downloadFile(documentData?.privacyFile?.fileType)
                                                            }}
                                                        >
                                                            Download
                                                        </Dropdown.Item>
                                                        <Dropdown.Item
                                                            className="font14 fw-medium"
                                                            onClick={() => {
                                                                deleteFile(documentData?.privacyFile?.fileType, documentData?.privacyFile?.fileLink)
                                                            }}
                                                        >
                                                            Delete
                                                        </Dropdown.Item>
                                                        </> : ''}
                                                    </div>
                                                    
                                                   
                                                </DropdownButton>
                                            </td>
                                        </tr>
                                        :
                                        ""}
                                      </>      
                                }
                                </tbody>
                            </table>
                        </div>

                    </div>
                </Container>

                <Container fluid className="mt-5 bg-white p-4 rounded shadow">
                    <div >
                        <div className="d-flex flex-wrap flex-lg-nowrap align-items-center justify-content-between" style={{ gap: '5px' }}>

                            <h1 className="font20 text-dark">Notifications Set</h1>
                            <Button variant="primary" className="fullRounded newCustomButton fw-bold font14 me-3 mb-2 mb-sm-0 responsive_wthTable"  style={{
                    backgroundColor: 'var(--newOrange)',
                    borderColor: 'var(--newOrange)',
                }} onClick={handleNotificationShow}>Create Notification</Button>
                        </div>
                        <div className="table-responsive mt-5">
                            <table className="table table_style">
                                <thead className='bgLightRed font14'>
                                    <tr>
                                        <th style={{ width: "135px" }}>Notification Type</th>
                                        <th style={{ width: "230px" }}>Email</th>
                                        <th style={{ width: "251px" }}>Last Updated On</th>
                                        <th style={{ width: "154px" }} className='text-center'>Action</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <>
                                        {notificationData?.map((data) => (
                                            <tr key={data._id}>
                                                <td className='font14 fw-medium'>{data.notification_type}</td>
                                                <td className="font14 fw-medium"> {data.email}</td>
                                                <td className="font14 fw-medium">{data.dateInEst}</td>
                                                <td style={{ cursor: "pointer" }} className='svg_style text-center'>
                                                    <DropdownButton
                                                        variant="white"
                                                        className="p-0 tableActionDropDown text-center"
                                                        title={
                                                            <div className="actionBtn">
                                                                <span></span>
                                                                <span></span>
                                                                <span></span>
                                                            </div>
                                                        }
                                                        drop="start"
                                                    >
                                                        <div style={{ overflowY: "auto", maxHeight: "100px" }}>
                                                            <Dropdown.Item
                                                                className="font14 fw-medium"
                                                                onClick={() => handleNotificationDelete(data._id)}
                                                            >
                                                                Delete
                                                            </Dropdown.Item>
                                                        </div>
                                                    </DropdownButton>
                                                </td>
                                            </tr>
                                        ))}
                                    </>
                                </tbody>
                            </table>
                        </div>
                    </div>

                    <Modal show={showNotificationModal} onHide={handleNotificationClose}>
                        <Modal.Header closeButton>
                            <Modal.Title>Upload Notification</Modal.Title>
                        </Modal.Header>
                        <Modal.Body>
                            <Form onSubmit={handleNotificationSubmit}>
                                <Form.Group className="mb-3">
                                    <Form.Label>Notification Type</Form.Label>
                                    <Form.Control
                                        as="select"
                                        name="notificationType"
                                        value={formData.notificationType}
                                        onChange={handleInputChange}
                                        required
                                    >
                                        <option value="" disabled>Select Notification Type</option>
                                        <option value="Invoice Template Notification">Invoice Template Notification</option>
                                        <option value="Business Threshold Notification">Business Threshold Notification</option>
                                        <option value="Order Issues Notification">Order Issues Notification</option>
                                    </Form.Control>
                                </Form.Group>
                                <Form.Group className="mb-3">
                                    <Form.Label>Email</Form.Label>
                                    <Form.Control
                                        type="email"
                                        name="email"
                                        value={formData.email}
                                        onChange={handleInputChange}
                                        required
                                    />
                                </Form.Group>
                                <Button variant="primary" type="submit" className="newCustomButton"  style={{
                                    backgroundColor: 'var(--newOrange)',
                                    borderColor: 'var(--newOrange)',
                                }}>
                                    Submit
                                </Button>
                            </Form>
                        </Modal.Body>
                    </Modal>
                </Container>
                
            </div>

            <Modal
                show={show}
                onHide={handleClose}
                backdrop="static"
                keyboard={false}
                size="md"
                centered
            >
                <Modal.Body>
                    <Col>
                        <img className="modal-img"
                            src="/assets/images/exclamation.svg"
                            alt=""
                        />
                        <br />
                        <br />
                        <h3 className="modal-text">There is one maintenance scheduled. If you want to update it, click the "Yes" button.</h3>
                        <br />
                        <Row className="modal-row">
                            <Col md={1}></Col>
                            <Col md={4}>
                                <Button className="btn btn-success success-btn"
                                    onClick={() => confirmSave("update")}
                                >
                                    <span><b>Yes</b></span>
                                </Button>
                            </Col>
                            <Col className="middle-col" md={2}></Col>
                            <Col md={4}>
                                <Button className="btn btn-primary success-btn" onClick={handleClose} >
                                    <span><b>Cancel</b></span>
                                </Button>
                            </Col>
                            <Col md={1}></Col>

                        </Row>
                        <br />
                    </Col>
                </Modal.Body>
            </Modal>

            <Modal 
               show={uploadModal}
               onHide={closeUploadModal}
                backdrop="static"
                keyboard={false}
                size="md"
                centered
            >
                <Modal.Body>
                    <Col lg="12">
                    <div className="col-12">
                    <div className="d-flex flex-column align-items-center justify-content-center">
                        <h3 className="mb-4 upload_heading_text">Terms of Use</h3>
                        <div className="image_upload_card">
                          <label htmlFor="upload_file" style={{cursor:"pointer"}}>
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width={130}
                            height={130}
                            viewBox="0 0 77 77"
                            fill="none"
                            >
                            <mask
                                id="mask0_697_226"
                                style={{ maskType: "alpha" }}
                                maskUnits="userSpaceOnUse"
                                x={0}
                                y={0}
                                width={85}
                                height={85}
                            >
                                <rect width="76.5083" height="76.5083" fill="#D9D9D9" />
                            </mask>
                            <g mask="url(#mask0_697_226)">
                                <path
                                d="M36.66 36.9179L31.0323 42.5273C30.7442 42.8257 30.384 42.9749 29.9518 42.9749C29.5195 42.9749 29.1481 42.8196 28.8375 42.509C28.4983 42.2106 28.3389 41.8346 28.3594 41.3809C28.3798 40.9272 28.5392 40.5512 28.8375 40.2529L36.4516 32.6388C36.9666 32.1239 37.5673 31.8664 38.2539 31.8664C38.9406 31.8664 39.5413 32.1239 40.0563 32.6388L47.6704 40.2529C47.9687 40.5512 48.1311 40.922 48.1577 41.3652C48.1843 41.8083 48.0218 42.191 47.6704 42.5133C47.372 42.8087 46.9991 42.9493 46.5515 42.935C46.104 42.9207 45.7249 42.7644 45.4143 42.466L39.8479 36.9179V55.4197C39.8479 55.9101 40.0522 56.3597 40.4609 56.7684C40.8696 57.1771 41.3192 57.3814 41.8096 57.3814H58.9749C61.2064 57.3814 63.0926 56.6111 64.6334 55.0703C66.1742 53.5295 66.9446 51.6433 66.9446 49.4118C66.9446 47.1803 66.1742 45.2942 64.6334 43.7534C63.0926 42.2126 61.2064 41.4422 58.9749 41.4422H54.1932V35.0665C54.1932 30.6567 52.6391 26.8977 49.531 23.7895C46.4228 20.6814 42.6638 19.1273 38.2539 19.1273C33.8441 19.1273 30.0851 20.6814 26.9769 23.7895C23.8688 26.8977 22.3147 30.6567 22.3147 35.0665H20.5982C17.6392 35.0665 15.0603 36.1557 12.8616 38.3341C10.6627 40.5124 9.56333 43.1424 9.56333 46.224C9.56333 49.3056 10.6525 51.9355 12.8309 54.1139C15.0092 56.2923 17.6392 57.3814 20.7208 57.3814H27.0965C27.5481 57.3814 27.9267 57.5344 28.2322 57.8403C28.5377 58.1463 28.6904 58.5253 28.6904 58.9775C28.6904 59.4298 28.5377 59.8081 28.2322 60.1126C27.9267 60.417 27.5481 60.5693 27.0965 60.5693H20.7208C16.7442 60.5693 13.3591 59.1864 10.5657 56.4206C7.77222 53.6547 6.37549 50.2743 6.37549 46.2791C6.37549 42.5028 7.67515 39.2291 10.2745 36.4581C12.8738 33.6872 15.9268 32.1975 19.4334 31.989C20.1486 27.3462 22.2841 23.5106 25.8398 20.4821C29.3954 17.4537 33.5335 15.9395 38.2539 15.9395C43.5822 15.9395 48.1021 17.7952 51.8137 21.5068C55.5252 25.2183 57.381 29.7383 57.381 35.0665V38.2544H59.3427C62.3957 38.3525 64.9573 39.4733 67.0274 41.6169C69.0974 43.7605 70.1324 46.3588 70.1324 49.4118C70.1324 52.5384 69.0749 55.1796 66.9599 57.3355C64.8449 59.4913 62.2241 60.5693 59.0975 60.5693H41.8096C40.3424 60.5693 39.1173 60.0778 38.1344 59.0949C37.1515 58.112 36.66 56.8869 36.66 55.4197V36.9179Z"
                                fill="var(--newOrange)"
                                />
                            </g>
                            </svg>
        
                          </label>
                          <input type="file" name="" id="upload_file" className="d-none" onChange={handleFileTerms} accept=".doc,.docx" />
                                          <div className="upload_down_btn d-flex align-items-center justify-content-center">
                                        <button className="position-relative newCustomButton" style={{
                                            backgroundColor: 'var(--newOrange)',
                                            borderColor: 'var(--newOrange)',
                                        }} onClick={uploadDocument} disabled={isUploadFile}>
                                            {isUploadFile ? <> Uploading... <ColorRing
                                                visible={true}
                                                height="25"
                                                width="25"
                                                ariaLabel="color-ring-loading"
                                                wrapperStyle={{}}
                                                wrapperClass="color-ring-wrapper"
                                                colors={['#fffff', '#fffff', '#fffff', '#fffff', '#fffff']}
                                            /> </> : "Save"}
                                        </button>
                                        <button className="newCustomButton"  style={{
                                            backgroundColor: 'var(--newOrange)',
                                            borderColor: 'var(--newOrange)',
                                        }} onClick={()=>{
                                    setFileName("")
                                    setSelectedFile(null)
                                }}>Clear</button>
                            </div>
                            <p className="mb-0 pdf_name">filename:{fileName}</p>
                            </div>
                    </div>
                </div>
                    </Col>
                </Modal.Body>
                <Modal.Footer>
                    <div>
                        <Button onClick={()=>closeUploadModal()} className="newCustomButton"  style={{
                    backgroundColor: 'var(--newOrange)',
                    borderColor: 'var(--newOrange)',
                }}>Close</Button>
                    </div>
                </Modal.Footer>
            </Modal>

            <Modal 
               show={uploadModalTwo}
               onHide={closeUploadModalTwo}
                backdrop="static"
                keyboard={false}
                size="md"
                centered
            >
                <Modal.Body>
                    <Col lg="12">
                    <div className="col-12">
                    <div className="d-flex flex-column align-items-center justify-content-center">
                        <h3 className="mb-4 upload_heading_text">Privacy Policy</h3>
                        <div className="image_upload_card">
                          <label htmlFor="upload_file" style={{cursor:"pointer"}}>
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width={130}
                            height={130}
                            viewBox="0 0 77 77"
                            fill="none"
                            >
                            <mask
                                id="mask0_697_226"
                                style={{ maskType: "alpha" }}
                                maskUnits="userSpaceOnUse"
                                x={0}
                                y={0}
                                width={85}
                                height={85}
                            >
                                <rect width="76.5083" height="76.5083" fill="#D9D9D9" />
                            </mask>
                            <g mask="url(#mask0_697_226)">
                                <path
                                d="M36.66 36.9179L31.0323 42.5273C30.7442 42.8257 30.384 42.9749 29.9518 42.9749C29.5195 42.9749 29.1481 42.8196 28.8375 42.509C28.4983 42.2106 28.3389 41.8346 28.3594 41.3809C28.3798 40.9272 28.5392 40.5512 28.8375 40.2529L36.4516 32.6388C36.9666 32.1239 37.5673 31.8664 38.2539 31.8664C38.9406 31.8664 39.5413 32.1239 40.0563 32.6388L47.6704 40.2529C47.9687 40.5512 48.1311 40.922 48.1577 41.3652C48.1843 41.8083 48.0218 42.191 47.6704 42.5133C47.372 42.8087 46.9991 42.9493 46.5515 42.935C46.104 42.9207 45.7249 42.7644 45.4143 42.466L39.8479 36.9179V55.4197C39.8479 55.9101 40.0522 56.3597 40.4609 56.7684C40.8696 57.1771 41.3192 57.3814 41.8096 57.3814H58.9749C61.2064 57.3814 63.0926 56.6111 64.6334 55.0703C66.1742 53.5295 66.9446 51.6433 66.9446 49.4118C66.9446 47.1803 66.1742 45.2942 64.6334 43.7534C63.0926 42.2126 61.2064 41.4422 58.9749 41.4422H54.1932V35.0665C54.1932 30.6567 52.6391 26.8977 49.531 23.7895C46.4228 20.6814 42.6638 19.1273 38.2539 19.1273C33.8441 19.1273 30.0851 20.6814 26.9769 23.7895C23.8688 26.8977 22.3147 30.6567 22.3147 35.0665H20.5982C17.6392 35.0665 15.0603 36.1557 12.8616 38.3341C10.6627 40.5124 9.56333 43.1424 9.56333 46.224C9.56333 49.3056 10.6525 51.9355 12.8309 54.1139C15.0092 56.2923 17.6392 57.3814 20.7208 57.3814H27.0965C27.5481 57.3814 27.9267 57.5344 28.2322 57.8403C28.5377 58.1463 28.6904 58.5253 28.6904 58.9775C28.6904 59.4298 28.5377 59.8081 28.2322 60.1126C27.9267 60.417 27.5481 60.5693 27.0965 60.5693H20.7208C16.7442 60.5693 13.3591 59.1864 10.5657 56.4206C7.77222 53.6547 6.37549 50.2743 6.37549 46.2791C6.37549 42.5028 7.67515 39.2291 10.2745 36.4581C12.8738 33.6872 15.9268 32.1975 19.4334 31.989C20.1486 27.3462 22.2841 23.5106 25.8398 20.4821C29.3954 17.4537 33.5335 15.9395 38.2539 15.9395C43.5822 15.9395 48.1021 17.7952 51.8137 21.5068C55.5252 25.2183 57.381 29.7383 57.381 35.0665V38.2544H59.3427C62.3957 38.3525 64.9573 39.4733 67.0274 41.6169C69.0974 43.7605 70.1324 46.3588 70.1324 49.4118C70.1324 52.5384 69.0749 55.1796 66.9599 57.3355C64.8449 59.4913 62.2241 60.5693 59.0975 60.5693H41.8096C40.3424 60.5693 39.1173 60.0778 38.1344 59.0949C37.1515 58.112 36.66 56.8869 36.66 55.4197V36.9179Z"
                                fill="var(--newOrange)"
                                />
                            </g>
                            </svg>
        
                          </label>
                          <input type="file" name="" id="upload_file" className="d-none" onChange={handleFileprivacy} accept=".doc, .docx" />
                                          <div className="upload_down_btn d-flex align-items-center justify-content-center">
                                <button className=" position-relative newCustomButton"  style={{
                    backgroundColor: 'var(--newOrange)',
                    borderColor: 'var(--newOrange)',
                }} onClick={uploadDocumnetPrivacy}>
                                            {isUploadFileTwo ? <> Uploading... <ColorRing
                                                visible={true}
                                                height="25"
                                                width="25"
                                                ariaLabel="color-ring-loading"
                                                wrapperStyle={{}}
                                                wrapperClass="color-ring-wrapper"
                                                colors={['#fffff', '#fffff', '#fffff', '#fffff', '#fffff']}
                                            /> </> : "Save"}
                                </button>
                                <button
                                className="newCustomButton"  style={{
                                    backgroundColor: 'var(--newOrange)',
                                    borderColor: 'var(--newOrange)',
                                }} onClick={()=>{
                                    setFileNameTwo("");
                                    setSelectedFileTwo(null)
                                }}>Clear</button>
                            </div>
                            <p className="mb-0 pdf_name">filename:{fileNameTwo}</p>
                            </div>
                    </div>
                </div>
                    </Col>
                </Modal.Body>
                <Modal.Footer>
                    <div>
                        <Button onClick={()=>closeUploadModalTwo()} className="newCustomButton"  style={{
                    backgroundColor: 'var(--newOrange)',
                    borderColor: 'var(--newOrange)',
                }}>Close</Button>
                    </div>
                </Modal.Footer>
            </Modal>
        </>
    )
}

export default Maintenance
